import type { ICON } from '@george-labs.com/george-assets/icons';
import { Avatar } from '@george-labs.com/design-system';

import { AccountType } from '@shared/products-types';

import type { Account } from '../aggregation-service/types/aggregationService';

export const getDisplayedProductIcon = (
    productType: AccountType,
    origin?: Account['origin'],
): ICON => {
    if (origin && origin !== 'CORE') {
        return Avatar.ICON.BANK;
    }

    if (productType === AccountType.CURRENT) {
        return Avatar.ICON.MONEY;
    }

    if (productType === AccountType.SAVING) {
        return Avatar.ICON.SAVINGS;
    }

    if (productType === AccountType.CARD_ACCOUNT) {
        return Avatar.ICON.MONEY_CARD;
    }

    if (productType === AccountType.LOAN) {
        return Avatar.ICON.BUILDING_SOCIETY_LOAN;
    }

    if (productType === AccountType.CREDIT_CARD) {
        return Avatar.ICON.VISACARD;
    }

    return Avatar.ICON.MONEY;
};
